import { render, staticRenderFns } from "./dynamic_routing.vue?vue&type=template&id=5f3f6502&scoped=true&"
import script from "./dynamic_routing.vue?vue&type=script&lang=js&"
export * from "./dynamic_routing.vue?vue&type=script&lang=js&"
import style0 from "./dynamic_routing.vue?vue&type=style&index=0&id=5f3f6502&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f6502",
  null
  
)

export default component.exports